import React, { useEffect } from 'react'
import { Outlet } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { getAppCurrentTheme } from '../../reducers/app'

export function GraphLayout() {
  const dispatch = useDispatch()
  useEffect(() => {
    dispatch(getAppCurrentTheme())
  }, [])

  return (
    <div className="page">
      <Outlet />
    </div>
  )
}
export default GraphLayout

GraphLayout.propTypes = {
}

GraphLayout.defaultProps = {
}
